export default __webpack_public_path__ + "static/media/discover_pic.f9810517.png";